import React from 'react';

export default function TextInputWithButton ({ value, buttonTitle, label, buttonClick, onChange}) {

    let inputProps = {
        type: 'text',
        onChange: (e) => onChange(e.target.value),
        value: value || '',
    };

    return (
        <div className="form-group skynet-form-input">
            <label>{label}</label>
                <div className="input-group">
                    <input className="form-control rounded-8" {...inputProps} />
                    <span className="input-group-btn">
                        <button className="btn btn-default" type="button" onClick={buttonClick}>{buttonTitle || 'Go'}</button>
                    </span>
                </div>
        </div>
    )
}